import { render, staticRenderFns } from "./JLedgerDemo.vue?vue&type=template&id=f6ed3dd2"
import script from "./JLedgerDemo.vue?vue&type=script&lang=js"
export * from "./JLedgerDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports